import React from 'react';

const PowerOfKnowledgeSection = () => {
  return (
    <section className="power-of-knowledge-section">
      <div className="container">
        <div className="section-content">
          <div className="text-content">
            <h2 className="section-heading">Become Dear to Lord Krishna</h2>
            
            <p className="main-text">
            ISKCON Boston is committed to providing inspiration and spiritual strength to its residents and congregational members, and the devotees of New Gundica Dhama strive to play their part in Sri Caitanya Mahaprabhu’s mission to spread Krishna consciousness throughout the greater Boston area. Recognizing that much of the world’s suffering stems from a lack of transcendental knowledge, we distribute Srila Prabhupada’s books so people can rediscover their eternal relationship with Lord Krishna and be elevated to Krishna consciousness—bringing true happiness, peace, and prosperity. Your donations make this service possible by enabling the sharing of Srila Prabhupada’s books.
            </p>
          </div>
          
          <div className="image-content">
            <div className="framed-image">
              <img
                src="https://i.postimg.cc/BnMGWVfc/book-distribution-cover-2.jpg"
                alt="Book Distribution in Action"
                className="section-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PowerOfKnowledgeSection;